import { Paper, Grid, Box, ClickAwayListener } from '@mui/material';
import React, { useRef } from 'react';
import { StyledButton } from '../../../common/components/Button';
import LanguageSelectionForm from '../../../common/components/LanguageSelectionForm';

import { GeneralContentProps } from '../../interfaces/generalContentProps';
import { GeneralContentStyles } from '../../styles';
import BackButton from '../BackButton';
import clsx from 'clsx';
import CkEditorContent from '../../../common/components/CkEditorContent';
import Transition from '../../../verticalTransition/components/Transition';
import { hexToRgba } from '../../utils/generalContent';
import { appendCdnToImagePath } from '../../../common/utils/appendCdnToImagePath';
import { BrandColors } from '../../../constants';
import { verticalTimeline } from '../../../verticalTransition/styles/verticalTimeline';
import { genericJourneyTheme } from '../../../common/styles/genericJourneyTheme';
import { TimeLineStyle } from '../../../store/interfaces';
import { useAppSelector } from '../../../store/hook';
const GeneralContentLayout4: React.FC<GeneralContentProps> = (props: GeneralContentProps): React.JSX.Element => {
  const {
    backgroundImageEnabled,
    backgroundColor,
    backgroundImage,
    contentContainerBackgroundColor,
    contentContainerOpacity,
    buttonText,
    buttonStyle,
    content,
    isICPEnabled,
    schedulableTaskItem,
    isNextItemAssessment,
    timeline: timelineContentPage,
  } = props;

  const {
    settings: {
      page: { backgroundImage: bgImage, timeline, containerColor },
    },
  } = useAppSelector((state) => state.template);

  const contentBgColor = hexToRgba(
    contentContainerBackgroundColor ? contentContainerBackgroundColor : containerColor || BrandColors.white,
    contentContainerOpacity,
  );

  const genericPath =
    backgroundImageEnabled && backgroundImage
      ? backgroundImage.path
      : backgroundImageEnabled && !backgroundImage
        ? bgImage?.path
        : '';
  const backgroundImagePath = genericPath ? appendCdnToImagePath(genericPath) : '';
  const { classes } = GeneralContentStyles({
    backgroundColor,
    backgroundImage: backgroundImagePath,
    contentBgColor,
    isICPEnabledCorrin: isICPEnabled,
  });

  const currentTimelineStyle: TimeLineStyle = {
    lineColor: timelineContentPage?.lineColor || timeline.lineColor,
    iconContainerColor: timelineContentPage?.iconContainerColor || timeline.iconContainerColor,
    iconColor: timelineContentPage?.iconColor || timeline.iconColor,
  };

  const { classes: classesTransition } = verticalTimeline(currentTimelineStyle);
  const { classes: classesJourneyTheme } = genericJourneyTheme();

  const scrollRef = useRef<HTMLDivElement>(null);

  /**
   * This change is specific to Corrin layout and solves issue CAW-1078.
   * If html overflow is hidden, then mui select will cause the issue in IE.
   * For IE, we need overflow to be hidden to solve background jitter.
   * Here, we set to hidden on mount, and reset on unmount.
   */
  React.useLayoutEffect(() => {
    if (window.navigator.userAgent.includes('Trident')) {
      document.documentElement.style.overflow = props.isLanguageSelectionFormOpen ? '' : 'hidden';

      return (): void => {
        document.documentElement.style.overflow = '';
      };
    }
  });

  return (
    <>
      <Grid
        data-testid="background-Corrin"
        className={`${clsx({
          [classes.bgImageCorrin]: backgroundImageEnabled,
          [classes.bgColorContainer]: true,
          [classes.minGridTransitionHeight]: true,
        })} `}>
        <div className={classesTransition.verticalGridContentPage}></div>
        <div className={classesJourneyTheme.upLayer}>
          <Transition isTrans={true} isNextItemAssessment={isNextItemAssessment} timelineStyles={currentTimelineStyle}>
            <Grid
              container
              alignItems="center"
              justifyContent="center"
              className={classesJourneyTheme.journeyThemeGrid}>
              <Grid item xs={12}>
                <Paper
                  elevation={contentContainerOpacity === 0 ? 0 : 1}
                  className={`
            ${classes.bgColorCard} 
            ${classesJourneyTheme.journeyThemePaper} 
            ${classesJourneyTheme.newTaskPaper}
            `}>
                  {/* Content Container */}
                  <div ref={scrollRef}>
                    <CkEditorContent
                      content={content}
                      pageStartTime={props.pageStartTime}
                      generalContentName={props.name}
                      taskName={props.taskName}
                    />

                    {/** Button */}

                    <Box
                      width="100%"
                      textAlign="center"
                      className={`
                ${classes.gridButton} 
                ${classesJourneyTheme.upLayer}`}>
                      <StyledButton
                        buttonText={buttonText}
                        buttonStyle={buttonStyle}
                        disabled={props.loading || props.isNextButtonDisabled}
                        onClickHandler={props.saveNGetNextWfItem}
                      />
                      {props.isLanguageSelectionFormOpen && !schedulableTaskItem && (
                        <Box className={`${classesJourneyTheme.upLayer}`}>
                          <div className={`${classesJourneyTheme.languageOverlay}`}></div>
                          <ClickAwayListener onClickAway={props.handleClickAwayLanguageSelection}>
                            <Box className={`${classes.languageSelectionOverlay}`}>
                              <Box textAlign="left" className={classes.languageSelectionModal}>
                                <LanguageSelectionForm
                                  languages={props.languages}
                                  onLanguageSubmit={props.onLanguageSubmit}
                                />
                              </Box>
                            </Box>
                          </ClickAwayListener>
                        </Box>
                      )}
                      {props.returnToTaskList && <BackButton />}
                    </Box>
                  </div>
                </Paper>
              </Grid>
            </Grid>
          </Transition>
        </div>
      </Grid>
    </>
  );
};

export default GeneralContentLayout4;
